import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'eq-list-header',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './list-header.component.html',
  styleUrl: './list-header.component.scss',
})
export class EqListHeaderComponent {

  @Input() centerLabel: string = '';
  @Input() rightButtonCondition: boolean = false;
  @Input() rightButtonLabel: string = '';
  @Input() rightButtonIcon: string = '';
  @Output() rightBtnClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  rightBtnClickEvent(): void {
    this.rightBtnClicked.emit();
  }
}
